import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import ArticleTags from "@/components/ArticleTags/ArticleTags.vue";
import RelatedContent from "@/components/RelatedContent/RelatedContent.vue";
import ArticleBody from "@/components/ArticleBody/ArticleBody.vue";
import ArticleComments from "@/components/ArticleComments/ArticleComments.vue";
import CMSService from "@/services/CMSService";
import { getArticleSlug, getCurrentSubdomain, capitalize } from "@/common/functions";

const TaboolaAd = () =>
    import(/* webpackChunkName: "TaboolaAd" */ "@/components/TaboolaAd/TaboolaAd.vue");

export default {
    name: "ArticleLayout",
    components: {
        Breadcrumb,
        ArticleTags,
        ArticleBody,
        ArticleComments,
        RelatedContent,
        TaboolaAd
    },
    data() {
        return {
            url: getArticleSlug(this.$route.path),
            title: "",
            articleBody: "",
            articleBodyTop: "",
            articleBodyMiddle: "",
            articleBodyBottom: "",
            tags: [],
            metaTitle: "",
            metaDescription: "",
            author: ""
        };
    },
    computed: {
        subdomain() {
            const currentSubdomain = getCurrentSubdomain();

            if (currentSubdomain === "esl") {
                return currentSubdomain.toUpperCase();
            } else {
                return capitalize(currentSubdomain);
            }
        }
    },
    methods: {
        async fetchContent() {
            let promise;
            if (/\/previewArticle/.test(this.$route.params.pathMatch)) {
                promise = CMSService.getArticlePreview(this.$route.query.id);
            } else {
                promise = CMSService.getArticles(this.url);
            }

            try {
                let response = await promise;
                const article = response.data.data;

                this.title = article.title;
                this.articleBody = this.setPDFLinkClass(article.body);
                this.tags = article.tags;
                this.author = article.author.displayName;

                const firstBreak = /.+?(?=<h2>)/im;
                const secondBreak = /.+?(?=<h2>)/gim;
                const thirdBreak = /^[^]*?<h2>[^]*?(<h2>[^]*?)$/;

                const articleSecondBreak = this.articleBody.match(secondBreak)[1];
                this.articleBodyTop = articleSecondBreak
                    ? this.articleBody.match(firstBreak)[0]
                    : "";
                this.articleBodyMiddle = articleSecondBreak
                    ? this.articleBody.match(secondBreak)[1]
                    : this.articleBody;
                this.articleBodyBottom = articleSecondBreak
                    ? this.articleBody.match(thirdBreak)[1]
                    : "";

                this.metaTitle = article.metaTitle || this.title;
                this.metaDescription = article.metaDescription;
            } catch (error) {
                if (typeof window.__PRERENDER_INJECTED !== "undefined") {
                    window.document.dispatchEvent(
                        new CustomEvent("spa-render-404", {
                            detail: { component: this }
                        })
                    );
                    return;
                }

                /**
                 * Eject the user to the subdomain home page
                 * if we don't have results for requested article
                 */
                window.location.assign("/");
            }
        },
        /**
         * This method adds "pdf-image-btn" and "pdf-btn" to links that allow
         * to download PDF files.
         */
        setPDFLinkClass(article) {
            return article
                .replace(/.pdf"><picture/gi, '.pdf" class="pdf-image-btn"><picture')
                .replace(/.pdf">View/gi, '.pdf" class="pdf-btn">View')
                .replace(
                    /view\?usp=sharing"><picture/gi,
                    'view?usp=sharing" class="pdf-image-btn"><picture'
                );
        }
    },
    mounted() {
        this.fetchContent();
    },
    metaInfo() {
        return {
            title: this.metaTitle,
            meta: [
                {
                    name: "description",
                    content: this.metaDescription
                },
                {
                    name: "author",
                    content: this.author
                }
            ],
            link: [
                {
                    rel: "canonical",
                    href: `https://${getCurrentSubdomain()}.yourdictionary.com` + this.$route.path
                }
            ]
        };
    }
};



// WEBPACK FOOTER //
// ./src/layouts/ArticleLayout/ArticleLayout.js